<template>
    <div v-cloak>
    </div>
</template>

<script>
export default {
    props: [
        'content',
        'id'
    ],
    methods: {
        closePost(id) {
            this.$modal.hide(id)
        }
    }
}
</script>
